import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { Controls } from '../../components/LandingPageV2/Controls';

export const ContactsControls = () => {
  return (
    <Controls>
      <Button size="M" theme="fill_primary" fullWidth>
        Заполнить заявку
      </Button>
      <Button size="M" theme="fill_secondary" fullWidth>
        Позвонить консультанту
      </Button>
    </Controls>
  );
};
